import {IAuthServiceV2} from "@volkswagen-onehub/authservice";

export interface IIdentityData {
    readonly lastAuthenticationDate: number;
}

export class IdentityDataClient {

    private readonly resourceHostId: string;

    constructor(private readonly authServiceWeConnectFag: IAuthServiceV2, stage: string) {
        this.resourceHostId = `myvw-customer-profile-${stage}`
    }

    public async getIdentityData(): Promise<IIdentityData> {
        const response = await this.authServiceWeConnectFag.get(this.resourceHostId,
            'v3/customers/__userId__/identityData')

        if (!response.ok) {
            throw new Error();
        }

        return await response.json();
    }
}